import { Button, Checkbox, Space, Stack, Title } from '@mantine/core';
import { useForm } from '@mantine/form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import classes from '../../../app.module.css';

export const Consent = () => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const form = useForm({
    mode: 'uncontrolled',
    validateInputOnChange: true,
    validate: {
      endUserAgreementConsent: (value) => (value === true ? null : ''),
      dataProcessingConsent: (value) => (value === true ? null : ''),
    },
  });

  return (
    <div>
      <form onSubmit={form.onSubmit(() => console.log('form submitted'))}>
        <Stack>
          <Title order={1}>{t('data_usage_title')}</Title>
          <p>{t('consent_message')}</p>

          <Checkbox
            variant="white"
            classNames={{ input: classes.checkboxInputVariant }}
            label={
              t('consent_end_user_agreement_1') +
              t('end_user_agreement') +
              ' & ' +
              t('data_protection_guidelines') +
              t('consent_end_user_agreement_2')
            }
            {...form.getInputProps('endUserAgreementConsent')}
          />
          <Checkbox
            variant="white"
            classNames={{ input: classes.checkboxInputVariant }}
            label={
              t('consent_data_processing_1') +
              t('data_processing_declaration') +
              t('consent_data_processing_2')
            }
            {...form.getInputProps('dataProcessingConsent')}
          />
          <Space h="md" />
          <Button
            disabled={!form.isValid()}
            type="submit"
            fullWidth
            onClick={() => {
              localStorage.removeItem('payment_intent');
              localStorage.removeItem('payment_intent_client_secret');
              void navigate('/measurement/order');
            }}
          >
            {t('start')}
          </Button>
        </Stack>
      </form>
    </div>
  );
};
